import { IStore } from 'store/types';

export const selectCalculatorPayees = () => (state: IStore) => state.tipCalculator?.payees;

export const selectCalculatorResults = () => (state: IStore) => state.tipCalculator?.results;

export const selectCalculatorPOSResults = () => (state: IStore) => state.tipCalculator?.posResults;

export const selectCalculatorPaymentSet = () => (state: IStore) => state.tipCalculator?.paymentSet;

export const selectCalculatorChangeLog = () => (state: IStore) => state.tipCalculator?.changeLog || [];
